<template>
  <div class="container">
    <h2 class="mb-5">Assign end applications</h2>
    <div class="text-right mb-3">
      <base-button radius="tr" component-class="green filled" @click.native="add(null, null)">
        <i class="fas fa-plus-circle mr-3"></i> ADD
      </base-button>
    </div>
    <div class="tree-container">
      <sl-vue-tree :value="applications" @drop="nodeDropped" ref="slVueTree">
        <template slot="title" slot-scope="{ node }">
          <div class="title" @dblclick="event => edit(event, node)">
            <span v-if="node.isLeaf" class="arrow" style="width: 21px !important;">&nbsp;</span>
            {{ node.title }}
          </div>
        </template>
        <template slot="toggle" slot-scope="{ node }">
          <span v-if="!node.isLeaf" class="arrow">
            <i v-if="node.isExpanded" class="fa fa-chevron-down"></i>
            <i v-if="!node.isExpanded" class="fa fa-chevron-right"></i>
          </span>
          <span v-if="node.isLeaf" class="arrow">&nbsp;</span>
        </template>
        <template slot="sidebar" slot-scope="{ node }">
          <span class="visible-icon" @click="event => visibility(event, node)">
            <i
              v-if="!node.data || node.data.visible !== false"
              class="fa fa-eye"
              title="Application visible now"
            ></i>
            <i
              v-if="node.data && node.data.visible === false"
              class="fa fa-eye-slash"
              title="Application is hidden."
            ></i>
          </span>
          <span
            :title="'Add application to ' + node.title"
            class="add-node"
            @click="event => add(event, node)"
          >
            <i class="fas fa-plus"></i>
          </span>
          <span
            :title="'Edit item ' + node.title"
            class="edit-node"
            @click="event => edit(event, node)"
          >
            <i class="fas fa-pen"></i>
          </span>
          <!-- <span
            v-if="node.data && node.data.canBeRemoved"
            title="Remove application"
            class="remove-node"
            @click="event => remove(event, node)"
          > -->
          <span
            v-if="node.data"
            title="Remove application"
            class="remove-node"
            @click="event => remove(node)"
          >
            <i class="fas fa-trash-alt"></i>
          </span>
        </template>
      </sl-vue-tree>

      <show-application-modal v-if="currentApplication" ref="modalCurrentApplication"></show-application-modal>

    </div>
    <div class="row mt-4">
      <div class="col-6 text-left">
        <base-button radius="bl" component-class="blue" @click.native="$router.push({ name: 'user.dashboard' })">
          <i class="fas fa-arrow-left mr-3"></i> Back
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import SlVueTree from 'sl-vue-tree';
import BaseButton from '@/components/inputs/button/BaseButton';
import { getNodeSiblings } from '@/helpers/sl-vue-tree';
import ShowApplicationModal from './ShowApplication';
import 'sl-vue-tree/dist/sl-vue-tree-minimal.css';

export default {
  computed: {
    ...mapState({
      currentApplication: state => state.applications.current,
      applicationParent: state => state.applications.parent
    }),
    applications() {
      return this.$store.getters['applications/treeApplications'];
    }
  },

  methods: {
    ...mapActions({
      getApplications: 'applications/getApplications',
      saveApplicationOrder: 'applications/saveOrder',
      changeApplicationVisibility: 'applications/changeVisibility',
      removeApplication: 'applications/remove',
    }),
    ...mapMutations({
      setCurrentApplication: 'applications/current',
      setApplicationParent: 'applications/applicationParent'
    }),
    nodeDropped() {
      const { slVueTree } = this.$refs;
      this.selectedNode = slVueTree.getSelected()[0];
      const { parent_id, parentNode } = getNodeSiblings(this.selectedNode, slVueTree);
      let { sibling_id } = getNodeSiblings(this.selectedNode, slVueTree);

      if (parentNode) {
        const lastParentChild = parentNode.children[parentNode.children.length - 1];
        if (lastParentChild.data.id === this.selectedNode.data.id) {
          sibling_id = null;
        }
      }

      this.saveApplicationOrder({
        materialId: this.selectedNode.data.id,
        parent_id,
        sibling_id,
      });
    },
    showDialog() {
      this.$nextTick(() => {
        this.$modal.show('show-application');
      });
    },
    edit(event, node) {
      this.setCurrentApplication(node.data);
      this.setApplicationParent(null);
      this.showDialog();
    },
    add(event, node) {
      this.setCurrentApplication({
        id: null,
        name: ''
      });
      if (!event && !node) {
        this.setApplicationParent(null);
      } else {
        this.setApplicationParent(node);
      }
      this.showDialog();
    },
    visibility(event, node) {
      const material = {
        ids: [node.data.id],
        visible: !node.data.visible
      };

      this.changeApplicationVisibility(material);
    },
    remove(node) {
      this.removeApplication(node.data.id);
    }
  },

  mounted() {
    this.getApplications();
  },

  components: {
    'show-application-modal': ShowApplicationModal,
    'base-button': BaseButton,
    'sl-vue-tree': SlVueTree
  }
};
</script>